
export default {
  data () {
    return {
      founders: [
        {
          name: `Oleg Rubinov - ${this.$t('about.founder')} / co-CEO / COO`,
          bio: this.$t('about.oleg'),
          image: '/images/oleg.jpg'
        },
        {
          name: `Peter Siemen - ${this.$t('about.founder')} / co-CEO / CTO`,
          bio: this.$t('about.peter'),
          image: '/images/peter.jpg'
        }
      ]
    }
  }
}
